export default __webpack_public_path__ + "static/media/DSC_0057.58fb9571.jpg";